import { ZipCodes } from './ZipCodes';

export class Residency extends ZipCodes {}
